import { render } from "./DialView.vue?vue&type=template&id=52871f8a&scoped=true"
import script from "./DialView.vue?vue&type=script&lang=js"
export * from "./DialView.vue?vue&type=script&lang=js"

import "./DialView.vue?vue&type=style&index=0&id=52871f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52871f8a"]])

export default __exports__